export const setErrorStatusState = status => {
  if (status === null) return false;
  return status;
};

export const resetErrorStatusState = status => {
  if (status === false) return null;
  return status;
};
